// src/js/utils/focusHandler.js

// Denna funktion lägger till/tar bort en klass på body för att hjälpa CSS
// att veta om användaren navigerar med musen eller tangentbordet.
export function initializeFocusHandler() {
    document.body.addEventListener('mousedown', function() {
        document.body.classList.add('using-mouse');
    });

    document.body.addEventListener('keydown', function(event) {
        if (event.key === 'Tab') {
            document.body.classList.remove('using-mouse');
        }
    });
    console.log('Focus Handler initialized.');
}